import { AssetType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredString } from '@/utils/zodUtils';

export const HomeImprovementDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      type: requiredEnum(AssetType, t),
      description: z.string().nullable(),
      workSiteAddress: requiredString(t),
    })
    .strict();

export type HomeImprovementDetailsFormType = z.infer<ReturnType<typeof HomeImprovementDetailsFormSchema>>;
